module.exports = (__webpack_require__(7))(454);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/platform-browser-dynamic/esm5/platform-browser-dynamic.js from dll-reference vendor
// module id = 616
// module chunks = 0